(($) => {
  const target = ".Cart__Main__Header__Count";
  const $target = $(target);
  // eslint-disable-next-line no-unused-vars
  $(document.body).on("wc_cart_emptied", (event) => {
    const text = $target.text().split(" ");
    const left = "(";
    const right = text.at(1).trim();

    $target.text(`${left} 0 ${right}`);
  });
  
  // eslint-disable-next-line no-unused-vars
  $(document.body).on("updated_cart_totals", (event) => {
    let cartTotals = 0;
    const $input = $(".shop_table input.qty");

    $input.each((index, el) => {
      cartTotals += parseInt($(el).val());
    });

    // const text = $target.text().split(" ");
    const left = "(";
    const right = cartTotals > 1 ? "items)" : "item)";
    $target.text(`${left}${cartTotals} ${right}`);
  });
// eslint-disable-next-line no-undef
})(jQuery);
